import { normalizeUserSession } from './userSession';
import configuracoesService from './configuracoesService';
import { API_ERROR_TYPES, ApiError, isNotFoundError } from './apiError';
import httpClient from './httpClient';

const validateEmail = (email) => {
  const normalizedEmail = email?.trim();
  if (!normalizedEmail) {
    throw new ApiError({
      type: API_ERROR_TYPES.VALIDATION_ERROR,
      code: 'EMAIL_REQUIRED',
      message: 'Email é obrigatório',
      fields: { email: 'Email é obrigatório' },
      operation: 'usuario.validarEmail',
    });
  }
  return normalizedEmail;
};

export const userVerificationService = {
  async checkUserExists(email) {
    const normalizedEmail = validateEmail(email);

    try {
      const data = await httpClient.get(
        `/user/verifica_cadastro/${encodeURIComponent(normalizedEmail)}?t=${Date.now()}`,
        { operation: 'usuario.verificarExistencia', cache: 'no-store' }
      );
      if (typeof data?.cadastrado !== 'boolean') {
        throw new ApiError({
          type: API_ERROR_TYPES.INVALID_RESPONSE,
          code: 'INVALID_USER_CHECK_RESPONSE',
          message: 'O servidor retornou uma resposta inválida',
          operation: 'usuario.verificarExistencia',
        });
      }
      return data.cadastrado;
    } catch (error) {
      if (isNotFoundError(error)) return false;
      throw error;
    }
  },

  async getUserData(email) {
    const normalizedEmail = validateEmail(email);

    try {
      const data = await httpClient.get(
        `/user/verificar/${encodeURIComponent(normalizedEmail)}?t=${Date.now()}`,
        { operation: 'usuario.carregar', cache: 'no-store' }
      );
      if (!data || typeof data !== 'object' || Array.isArray(data)) {
        throw new ApiError({
          type: API_ERROR_TYPES.INVALID_RESPONSE,
          code: 'INVALID_USER_RESPONSE',
          message: 'O servidor retornou dados de usuário inválidos',
          operation: 'usuario.carregar',
        });
      }
      const config = await configuracoesService.carregarConfiguracoes(normalizedEmail);
      return normalizeUserSession({ ...data.user, configuracoes: config.configuracoes });
    } catch (error) {
      if (isNotFoundError(error)) return null;
      throw error;
    }
  },

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
};

export default userVerificationService;
